import ServiceErrorPage from "@/presentation/serviceError/ServiceErrorPage";
import { ReactNode } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

interface Props {
    children: ReactNode;
}

const ErrorFallback = () => <ServiceErrorPage withLogout={false} />;

const ErrorBoundary = ({ children }: Props) => (
    <ReactErrorBoundary FallbackComponent={ErrorFallback}>
        {children}
    </ReactErrorBoundary>
);

export default ErrorBoundary;
